@let baseColor = (color() | labels).color;

<div
  class="palantir-tag"
  [class.minified]="minified()"
  [class.palantir-tag--activatable]="activatable()"
  [ngClass]="[
    'palantir-tag__size--' + size(),
    'palantir-tag__style--' + style(),
    'palantir-tag__shape--' + shape(),
  ]"
  [style.--palantir-tag-color]="baseColor"
>
  @if (prefix()) {
    <palantir-icon [name]="prefix()" />
  }

  @if (!prefix() && !suffix() && minified()) {
    <palantir-icon name="info-filled" />
  }

  <span>
    <ng-content />
  </span>

  @if (suffix()) {
    <palantir-icon [name]="suffix()" />
  }
</div>
